// extracted by mini-css-extract-plugin
export default {"Review":"Review_Review__l0eOS","allReviews":"Review_allReviews__eWU3W"};